.expectationReportedRoot {
  margin-bottom: 12px;
}

.successCard {
  background-color: var(--viz-bullish-soft);
  border: 1px solid var(--viz-bullish);
  color: var(--viz-bullish);
}

.criticalCard {
  background-color: var(--viz-bearish-soft);
  border: 1px solid var(--viz-bearish);
  color: var(--viz-bearish);
}
